/**
 * 权限的枚举
 * ASSISTANT: 智能问答助手
 * COLLECT: 收藏
 * HISTORY 历史
 * LANGUAGE 语言
 * * 使用方法: 把需要的枚举加起来就行了,例如需要智能问答助手和收藏的权限则EAuthority.ASSISTANT + EAuthority.COLLECT 即可
 */
export enum EAuthority {
  ASSISTANT = 0b001,
  HISTORY = 0b010,
  LANGUAGE = 0b100,
}

export enum ELanguage {
  EN = 'en',
  ZH = 'zh',
}

export enum EUserType {
  USER = 'user',
  ASSISTANT = 'assistant',
}

export enum EMessageType {
  /** 文件预设信息 */
  PRE_FILE,
  /** 全局预设信息 */
  PREINSTALLED,
  /** 提问 */
  QUESTION,
  /** 原料回答 */
  MATERIAL,
  /** 回复 */
  REPLY,
  /** 范围 */
  RANGE,
  /** 原料预设信息 */
  PREINSTALLED_MATERIAL,
  /** 找文件预设信息 */
  PREINSTALLED_FIND_FILE,
  /** 问答预设信息 */
  PREINSTALLED_QUESTION,
}

export enum EIntelligentType {
  FILE = 1,
  GLOBAL = 2,
  QUESTION = 3,
  FIND_FILE = 4,
  MATERIAL = 5,
}
